import { render } from "./Notification.vue?vue&type=template&id=16800fd2&ts=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=16800fd2&lang=css"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__